import React from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  label: string;
  onChange: (val: string) => void;
}

const EditableHeader = React.memo(({ label, onChange }: Props) => {
  const [value, setValue] = React.useState(label);
  const { setValue: setFormValue } = useFormContext();

  React.useEffect(() => {
    setValue(label);
  }, [label]);

  // 한글 조합 깨짐 방지
  const handleComposition = React.useCallback(() => {
    onChange(value);

    setFormValue("__meta_column_label_changed", Date.now(), {
      shouldDirty: true,
    });
  }, [onChange, value]);

  return (
    <input
      className="w-28 text-xs text-gray-A px-1 py-0.5 border rounded"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleComposition}
    />
  );
});
export default EditableHeader;
